import React, {useEffect, useState} from 'react';

const Subscribe = () => {
	return (
		//TODO Send the events to the database
		<div style={{minHeight: '1000px', textAlign: 'center'}}>
			<h1 style={{marginTop: '100px', backgroundColor: 'lightgrey'}}>
				Welcome Aboard !!
			</h1>
		</div>
	)
};

export default Subscribe;
